import { useEffect, useRef, useState } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import ModalPop from "../../home/ModalPop";

export const HeaderCategoryList = [
  {
    id: 1,
    title: `집치워드림\u00A0센터`,
    link: "#about",
  },
  {
    id: 2,
    title: `유품\u00A0·\u00A0생전정리`,
    link: "",
  },
  {
    id: 3,
    title: `특수`,
    sub: `(쓰레기집,\u00A0고독사\u00A0등)`,
    link: "",
  },
  {
    id: 4,
    title: `일반정리`,
    sub: `(빈집,\u00A0창고\u00A0등)`,
    link: "",
  },
  {
    id: 5,
    title: `생활\u00A0폐기물처리`,
    link: "",
  },
  {
    id: 6,
    title: `<span class="text-[#00bf19]">BLOG</span>\u00A0작업사례`,
    link: "https://blog.naver.com/ranger9591",
  },
  {
    id: 7,
    title: `고객\u00A0REVIEW`,
    link: "#review",
  },
  {
    id: 8,
    title: `상세\u00A0견적문의`,
    link: "#contact",
  },
];

const MHeader = () => {
  const [opened, { toggle }] = useDisclosure(false);

  const [headerStyle, setHeaderStyle] = useState({ backgroundColor: "white" });

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const menuOnclick = (link: string) => {
    let menuHeight = document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight + 120,
        behavior: "smooth",
      });
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     if (window.pageYOffset > 150)
  //       setHeaderStyle({ backgroundColor: "white" });
  //     else setHeaderStyle({ backgroundColor: "transparent" });
  //   });
  //   return () => {
  //     window.removeEventListener("scroll", () => {
  //       if (window.pageYOffset > 150)
  //         setHeaderStyle({ backgroundColor: "white" });
  //       else setHeaderStyle({ backgroundColor: "transparent" });
  //     });
  //   };
  // }, []);

  const phoneMenuOnclick = (link: string) => {
    let menuHeight = document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <header className="fixed left-0 top-0 w-full h-fit z-10 ">
        <div
          ref={headerRef}
          id="header"
          // style={headerStyle}
          className="relative w-full h-fit px-2 lg:px-[calc((100%-var(--container))/3)] max-h-20 lg:max-h-32 py-2 lg:pb-0 lg:pt-5 overflow-hidden bg-white z-40"
        >
          <div className="relative w-full h-full flex justify-between items-center xl:items-end gap-6 xl:gap-4 pt-2">
            <Burger
              ref={burgerIconRef}
              opened={opened}
              onClick={toggle}
              className="block xl:hidden"
              size="md"
              color="green"
            />
            <div className="relative w-auto h-full">
              <img
                alt="집치워드림센터 로고"
                onClick={() => (window.location.href = "/")}
                className="!relative w-auto h-full max-h-12 lg:max-h-14 xl:max-h-20 py-1 lg:pb-2 object-contain cursor-pointer"
                src="/images/logo.png"
                width={341}
                height={113}
              />
            </div>
            <div className="hidden xl:flex relative w-fit h-fit justify-between items-start gap-2">
              <div className=" relative w-fit h-fit">
                <img
                  onClick={openfunc}
                  className="!relative w-full h-full max-h-12 object-contain cursor-pointer"
                  alt="집치워드림센터 무료 출장견적 문의 버튼"
                  src={"images/headerContactBtn.png"}
                  width={645}
                  height={105}
                />
              </div>
              <div className=" relative w-fit h-fit">
                <img
                  onClick={() => window.open("https://open.kakao.com/o/scbfZxci")}
                  className="!relative w-full h-full max-h-9 object-contain cursor-pointer"
                  alt="집치워드림센터 카카오톡 상담 버튼"
                  src={"images/headerKakaoBtn.png"}
                  width={367}
                  height={74}
                />
              </div>
              <div className=" relative w-fit h-fit">
                <img
                  onClick={() => window.open("https://blog.naver.com/ranger9591")}
                  className="!relative w-full h-full max-h-9 object-contain cursor-pointer"
                  alt="집치워드림센터 네이버 블로그 바로가기 버튼"
                  src={"images/headerBlogBtn.png"}
                  width={341}
                  height={72}
                />
              </div>
            </div>
            <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
              <IconBrandWhatsapp
                onClick={() => {
                  window.location.href = "tel:010-2075-4527";
                }}
                size={30}
                stroke={1}
                className="text-primary"
              />
            </div>
            <div className="hidden xl:block relative w-fit h-fit">
              <img
                onClick={() => {
                  window.location.href = "tel:010-2075-4527";
                }}
                className="!relative w-full h-full max-h-10 lg:max-h-12 xl:max-h-16 lg:pb-3 object-contain cursor-pointer"
                alt="집치워드림센터 전화상담 010-2075-4527 버튼"
                src={"images/rightNum.png"}
                width={525}
                height={116}
              />
            </div>
          </div>
        </div>
        <div
          // style={headerStyle}
          className="hidden xl:block relative w-full h-fit lg:px-[calc((100%-var(--container))/3)] overflow-hidden z-40 border-t border-b bg-primary"
        >
          <ul className="hidden relative w-full h-fit max-w-screen-lg xl:max-w-screen-3xl mx-auto border-l text-center xl:grid items-center justify-items-center grid-cols-8 cursor-pointer">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i + "pc"}
                onClick={() => {
                  v.link.includes("#")
                    ? menuOnclick(v.link)
                    : v.link.includes("https")
                      ? window.open(v.link)
                      : openfunc();
                }}
                className={
                  v.id === 8
                    ? "text-center relative w-full h-fit border-r bg-secondary text-white py-2"
                    : "text-center relative w-full h-fit border-r bg-white py-2"
                }
              >
                <p className={v.id === 1 ? "text-primary" : v.title.includes("BLOG") ? "hidden" : "block"}>
                  {v.title}
                  <small>{v.sub}</small>
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: v.title.includes("BLOG") ? v.title : "",
                  }}
                ></p>
              </li>
            ))}
          </ul>
        </div>
        <div
          ref={phoneMenuListRef}
          className="block xl:hidden fixed top-16 left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
        >
          <ul className="border-b bg-white text-font">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i}
                onClick={() => {
                  v.link.includes("#") ? phoneMenuOnclick(v.link) : v.id > 3 ? window.open(v.link) : openfunc();
                }}
                className="border-b py-4 text-center"
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: v.title.includes("BLOG") ? v.title : "",
                  }}
                ></p>
                <p className={v.id === 1 ? "text-primary" : v.title.includes("BLOG") ? "hidden" : "block"}>
                  {v.title}
                  <small>{v.sub}</small>
                </p>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </>
  );
};

export default MHeader;
